import { useTranslation } from 'react-i18next';
import { BrowserOnly } from '../../client/BrowserOnly';
import { fetchAddressSuggestions, resolveAddressSuggestionLocation } from '../../api';
import type { OrderLocation } from '../../types';
import SharedAddressAutocomplete, {
  type AddressAutocompleteSource,
} from '../../../miniapp/ui-kit/AddressAutocomplete';

const websiteAddressSource: AddressAutocompleteSource = {
  fetchSuggestions: fetchAddressSuggestions,
  resolveLocation: resolveAddressSuggestionLocation,
};

interface AddressAutocompleteProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  onLocationChange: (location: OrderLocation | null) => void;
  placeholder?: string;
}

export default function AddressAutocomplete(props: AddressAutocompleteProps) {
  const { t } = useTranslation();

  return <BrowserOnly reason="Google Maps JS API is browser-only" fallback={<input id={props.id} disabled value={props.value} placeholder={props.placeholder ?? t('cart.deliveryPlaceholder')} aria-label={props.placeholder ?? t('cart.deliveryPlaceholder')} className="w-full rounded-4xl bg-secondary" />}>
    <SharedAddressAutocomplete
      {...props}
      source={websiteAddressSource}
      loadingLabel={t('website.addressAutocomplete.loadingSuggestions')}
      inputClassName="rounded-4xl bg-secondary"
      listClassName="top-[calc(100%+6px)] max-h-[240px] rounded-4xl shadow-ambient"
    />
  </BrowserOnly>;
}
